export var en = {
  weekDay: {
    abbr: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
  }
};